import { List as ImmutableList } from 'immutable';

import { chartOfAccountsSelectors } from 'app-components/flux/chart-of-accounts';
import { transactionsTypes, transactionsUtils } from 'app-components/flux/transactions';
import { getLogger } from 'app-components/utils/core';

import { transactionsSortFunction } from 'data/transactions/utils';

const log = getLogger('data/transactionList/selectors');

export function sortTransactions(txns, optSortBy, optSortOrder) {
  const sortBy = optSortBy !== undefined ? optSortBy : 'date';
  const sortOrder = optSortOrder !== undefined ? optSortOrder : 'descending';

  log.log('In selector performing SORT', sortBy, sortOrder);
  const sortFactor = sortOrder === 'ascending' ? 1 : -1;

  const sortedTxns = ImmutableList(txns.toList()).sort((a, b) => {
    let cmpValue = 0;
    switch (sortBy) {
      case 'payee':
        cmpValue = 1;

        if (a.payee === b.payee) {
          cmpValue = transactionsSortFunction(a, b);
          // sometimes payee can be null
        } else if ((a.payee || '').toLowerCase() < (b.payee || '').toLowerCase()) {
          cmpValue = -1;
        }
        break;
      case 'check': {
        cmpValue = 1;

        const aChecknum = (a.check && a.check.number) || '';
        const bChecknum = (b.check && b.check.number) || '';

        if (aChecknum === bChecknum) {
          cmpValue = transactionsSortFunction(a, b);
        } else if (Number.isNaN(Number(aChecknum)) || Number.isNaN(Number(bChecknum))) {
          cmpValue = aChecknum.toLowerCase() < bChecknum.toLowerCase() ? -1 : 1;
        } else {
          cmpValue = Number(bChecknum) - Number(aChecknum);
          // cmpValue = -1;
        }
        break;
      }
      case 'amount':
        cmpValue = 1;

        if (Number(a.amount) === Number(b.amount)) {
          cmpValue = transactionsSortFunction(a, b);
        } else if (Number(a.amount) < Number(b.amount)) {
          cmpValue = -1;
        }
        break;
      case 'category': {
        const strA = a.coa ? chartOfAccountsSelectors.getCoaStringSelector(undefined, a.coa, true) : '';
        const strB = b.coa ? chartOfAccountsSelectors.getCoaStringSelector(undefined, b.coa, true) : '';
        cmpValue = 1;

        if (strA === strB) {
          cmpValue = transactionsSortFunction(a, b);
        } else if (strA.toLowerCase() < strB.toLowerCase()) {
          cmpValue = -1;
        }
        break;
      }

      // TODO: remove 'date' and 'status' cases here once old register is updated/replaced (deprecatedRegister)
      case 'reviewed':
      case 'status':
      case 'state':
        cmpValue = transactionsTypes.statusOrder.indexOf(a.state) - transactionsTypes.statusOrder.indexOf(b.state);
        if (cmpValue === 0) {
          // for cash-flow uses, secondary-sort needs to be on date
          cmpValue = transactionsSortFunction(a, b);
        }
        break;

      case 'date':
      case 'postedOn':
        cmpValue = transactionsSortFunction(a, b);
        break;

      case 'action':
        {
          const valueA = transactionsUtils.InvestmentTxnActionsByType[a.investmentTxnType];
          const valueB = transactionsUtils.InvestmentTxnActionsByType[b.investmentTxnType];
          cmpValue = valueA?.localeCompare(valueB);
        }
        break;
      case 'security':
        {
          const valueA = `${a.symbol} ${a.securityName}`;
          const valueB = `${b.symbol} ${b.securityName}`;
          cmpValue = valueA?.localeCompare(valueB);
        }
        break;
      case 'description':
        {
          const valueA = transactionsUtils.investmentTransactionDescription(a);
          const valueB = transactionsUtils.investmentTransactionDescription(b);
          cmpValue = valueA?.localeCompare(valueB);
        }
        break;
      case 'quantity':
        {
          const valueA = Number.isNaN(Number(a.units)) ? 0 : Math.abs(a.units);
          const valueB = Number.isNaN(Number(b.units)) ? 0 : Math.abs(b.units);
          cmpValue = valueA - valueB;
        }
        break;
      case 'price':
        cmpValue = transactionsUtils.calcPricePerUnit(a) - transactionsUtils.calcPricePerUnit(b);
        break;
      case 'commission':
        cmpValue = a.commission - b.commission;
        break;
      default:
        verify(false, `unexpected sortBy = '${sortBy}' key`);
        break;
    }

    // if all else equal, sort by ID to guarantee repeatable sorting
    if (cmpValue === 0) {
      cmpValue = a.id - b.id;
    }

    return cmpValue * sortFactor;
  });

  return sortedTxns;
}
